import Config from '@/app.config'

/**
 * Mounts the core config in '/src/app.config.js' to Vue.$config
 *
 * @export Function The plugin.
 * @returns The plugin.
 */
export default function plugin() {

    return function install(Vue) {

        Object.defineProperty(Vue.prototype, '$config', {
            get() {
                return Config
            },
        })
    }
}
